"use client";
import Footer from "components/General/Footer/Footer";
import Header from "components/General/Header/Header";
import MainMenuExpanded from "components/General/Header/MainMenu/MainMenuExpanded";
import { usePathname } from "next/navigation";
import { useEffect, useState, useContext } from "react";
import BreadCrumbs from "./BreadCrumbs/BreadCrumbs";
import { SettingsContext } from "context/SettingsContextProvider";

const PageLayout = ({ front, breadcrumbs, children }) => {
  const path = usePathname();
  const [shrinkHeight, setShrinkHeight] = useState(false);
  const { settings } = useContext(SettingsContext);

  function onScroll({ scroll }) {
    const threshold = 40;
    setShrinkHeight(scroll > threshold);
  }

  useEffect(() => {
    (async () => {
      const LocomotiveScroll = (await import("locomotive-scroll")).default;

      const LenisSmoothScroll = new LocomotiveScroll({
        lenisOptions: {
          lerp: 0.15,
          smoothTouch: false,
        },
        scrollCallback: onScroll,
      });

      LenisSmoothScroll.lenisInstance.options.content.addEventListener(
        "wheel",
        (event) => {
          const paths = event.composedPath();

          paths.find((el) => {
            if (
              el instanceof HTMLElement &&
              (el?.getAttribute("id") == "modalSelector" ||
                el?.getAttribute("id") == "slideOverSelector")
            ) {
              event.stopPropagation();
              return;
            }
          });
        }
      );
    })();

    return () => {};
  }, [path]);

  return (
    <div>
      <Header
        shrinkHeight={shrinkHeight}
        main_menu={settings?.menus?.main_menu}
        top_menu={settings?.menus?.top_menu}
      />
      <main
        className={`min-h-[calc(100vh-30rem)] ${
          front ? "lg:pt-[11.5rem] pt-36" : "lg:pt-[12rem] pt-40"
        }`}
      >
        <BreadCrumbs front={front} breadcrumbs={breadcrumbs} />
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PageLayout;
